import React from 'react';
import { Link } from 'react-router-dom';
import { FiBell, FiExternalLink } from 'react-icons/fi';

interface HeaderProps {
  showSubscribe?: boolean;
}

const Header: React.FC<HeaderProps> = ({ showSubscribe = true }) => {
  return (
    <header className="bg-white border-b border-gray-200">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          {/* Logo and Brand */}
          <Link to="/" className="flex items-center gap-3">
            <div className="w-8 h-8 bg-brand-500 rounded-lg flex items-center justify-center">
              <svg className="w-5 h-5 text-white" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                <path d="M9 12l2 2 4-4" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </div>
            <div>
              <span className="font-semibold text-gray-900">ChecksAndTicks</span>
              <span className="text-gray-500 ml-1">Status</span>
            </div>
          </Link>

          {/* Actions */}
          <div className="flex items-center gap-4">
            {showSubscribe && (
              <Link
                to="/subscribe"
                className="inline-flex items-center gap-2 px-4 py-2 text-sm font-medium text-gray-700 bg-gray-100 hover:bg-gray-200 rounded-lg transition-colors"
              >
                <FiBell className="w-4 h-4" />
                Subscribe
              </Link>
            )}
            <a
              href="https://checksandticks.com"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-1 text-sm text-gray-500 hover:text-gray-700 transition-colors"
            >
              Visit App
              <FiExternalLink className="w-3.5 h-3.5" />
            </a>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
